gs.component('customerSearch', {
    templateUrl: 'components/customersearch/customersearch.html',
    link: function (DI) {
        var _this = this;
        var info;
        this.tabs = [];
        this.activeTab = null;
        this.error = false;
        this.staffnext = DI.$rootScope.staffnext;
        this.goInForm = function () {
            for (var _i = 0, _a = _this.tabs; _i < _a.length; _i++) {
                var t = _a[_i];
                if (t.id === 'filter') {
                    _this.setTab(t);
                    return;
                }
            }
        };
        this.setTab = function (tab) {
            _this.error = false;
            DI.$location.search('tab', tab.id);
        };
        var getReports = function () {
            return DI.$q.promise(function (resolve) {
                DI.server.get('/api/stats/generic/reports/get?order=1').then(function (reports) {
                    _this.tabs = reports.filter(function (r) {
                        return r.customer_tab || r.id === 'advanced' || (r.id === 'filter' && DI.$rootScope.hasPermission('Download customer register'));
                    }).map(function (r) {
                        if (r.id === 'advanced') {
                            r.name = 'Advanced search';
                            return r;
                        }
                        if (r.id === 'filter') {
                            r.name = 'Filter search';
                            return r;
                        }
                        r.name = r.data.name;
                        r.data.name = null;
                        if (r.order == null)
                            r.order = 50;
                        r.locked = !DI.$rootScope.hasPermission('Settings');
                        return r;
                    });
                    _this.tabs.sort(function (a, b) { return a.order - b.order; });
                    if (_this.activeTab)
                        _this.activeTab = _.findWhere(_this.tabs, { id: _this.activeTab.id });
                    resolve();
                });
            });
        };
        DI.live.subscribe({ type: 'report', callback: getReports, scope: this });
        var loadInfo = function () {
            return DI.$q.promise(function (resolve) {
                DI.server.get('/api/stats/generic/info').then(function (result) {
                    _.keys(result.properties).forEach(function (dt) {
                        var props = result.properties[dt];
                        props.forEach(function (p) {
                            if (p.datatype) {
                                p.datatype = _.findWhere(result.datatypes, { id: p.datatype });
                            }
                            if (p.joinedproperty) {
                                p.joinedproperty = _.findWhere(result.datatypes, { id: p.joinedproperty });
                            }
                        });
                    });
                    _this.info = info = result;
                    _this.header.fields = result.properties.user.filter(function (f) {
                        if (f.format === 'bool' || f.format === 'image')
                            return false;
                        return f.id.indexOf('.') < 0;
                    });
                    resolve();
                });
            });
        };
        var updateTab = function () {
            if ((DI.$location.path() !== '/customers/search') && (DI.$location.path() !== '/customers/active'))
                return;
            var args = DI.$location.search();
            if (args && args.tab) {
                var id = isNaN(args.tab) ? args.tab : Number(args.tab);
                _this.activeTab = _.findWhere(_this.tabs, { id: id });
            }
            if (!_this.activeTab && DI.$location.path() === '/customers/search') {
                _this.activeTab = _this.tabs[0];
            }
            else if (!_this.activeTab && DI.$location.path() == '/customers/active') {
                _this.activeTab = _.findWhere(_this.tabs, { name: 'Active memberships' });
            }
            reloadReport();
        };
        DI.$q.all([getReports(), loadInfo()]).then(updateTab);
        this.$on('$locationChangeSuccess', updateTab);
        this.saveReportOption = { forceCustomerTab: true };
        this.statisticsBuilderOption = { presetCustomer: true };
        var excelLoading = false;
        var getExcel = function () {
            excelLoading = true;
            return DI.server.post('/api/stats/generic/excel', getReportConfig({}), null, null, null, null, {
                responseType: 'blob'
            }).then(function (response) {
                if (response.success) {
                    DI.util.download(DI.$filter('translate')(_this.activeTab.name) + '.xlsx', null, null, response.data);
                }
            })["finally"](function () {
                excelLoading = false;
            });
        };
        var memberRequest = function (props) {
            return DI.$q.promise(function (resolve, reject) {
                DI.server.post2('/api/stats/generic/user/get', {
                    report: getReportConfig({}),
                    fields: props
                }).then(function (response) {
                    response.forEach(function (m) { m.isMember = true; });
                    resolve(response);
                }, reject);
            });
        };
        var sendMailing = function () {
            memberRequest([]).then(function (receivers) {
                _this.pubsub.publish('newmailingdata', {
                    isNewsOrAdvertising: false,
                    sendOption: 'mail',
                    receivers: receivers,
                    options: { 'callCloseOnSuccess': true, 'modalMode': false, noRedirect: true }
                });
                DI.$modal.open({
                    templateUrl: 'views/mailingnew.html',
                    windowClass: 'huge-modal-window',
                    controller: 'NewMailingCtrl'
                }).result.then(_this.$close);
            });
        };
        var syncMailChimp = function () {
            memberRequest(['mail', 'firstname', 'lastname']).then(function (result) {
                DI.$modal.open({
                    templateUrl: 'views/mailchimp.html',
                    controller: 'MailChimpCtrl',
                    resolve: {
                        items: function () {
                            return result;
                        }
                    }
                });
            });
        };
        var invite = function () {
            memberRequest([]).then(function (result) {
                DI.$modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: 'NewMemberInvitationAddModalCtrl',
                    resolve: {
                        invites: function () {
                            return result;
                        }
                    }
                });
            });
        };
        //
        this.header = {
            searchText: '',
            field: null,
            fields: [],
            getNumberOfMatches: function () { return _this.tableConfig && _this.tableConfig.async.count; }
        };
        this.header.buttons = [
            { title: 'Send mailing', onClick: sendMailing, visible: function () { return DI.$rootScope.hasPermission('Mailing handling'); } },
            { title: 'Download as Excel', onClick: getExcel, loading: function () { return excelLoading; }, visible: function () { return DI.$rootScope.hasPermission('Download customer register'); } },
            { title: 'Sync with MailChimp', onClick: syncMailChimp, visible: function () { return DI.$rootScope.hasPermission('Sync with MailChimp'); } },
            { title: 'Invite new ones', showOnEmpty: true, onClick: invite, visible: function () { return DI.$rootScope.hasModule('Chain') && DI.$rootScope.hasPermission('Send mail'); } }
        ];
        var prevSearchText, prevFieldId;
        this.filterChanged = _.debounce(function () {
            var fieldId = _this.header.field && _this.header.field.id || 'name';
            var searchText = _this.header.searchText;
            if (searchText !== prevSearchText || (prevFieldId !== fieldId && searchText)) {
                reloadReport();
            }
            prevSearchText = searchText;
            prevFieldId = fieldId;
        }, 250);
        var orderOption;
        var reloadReport = function () {
            if (!_this.activeTab)
                return;
            if (_this.activeTab.id === 'advanced' || _this.activeTab.id === 'filter')
                _this.reportType = null;
            else
                _this.reportType = _this.activeTab.data.reporttype;
            _this.reportId = null;
            if (_this.reportType === 'list') {
                orderOption = null;
                reload({ limit: 75 }).then(function (response) {
                    _this.tableConfig = DI.showreport.createTableConfig(response, info);
                    _this.tableConfig.hideSearchCount = true;
                    _this.tableConfig.async = {
                        count: response.row_count,
                        fetchPage: function (option) {
                            orderOption = option.order;
                            return DI.$q.promise(function (resolve) {
                                reload(option).then(function (data) {
                                    DI.showreport.createTableConfig(data, info); // convert data
                                    _this.tableConfig.async.count = response.row_count = data.row_count;
                                    resolve(data.data);
                                });
                            });
                        }
                    };
                });
            }
            else if (_this.reportType) {
                _this.tableConfig = null;
                _this.reportId = _this.activeTab.id;
            }
        };
        var extendFilter = function (data, filters) {
            if (data.filter)
                filters.unshift(data.filter);
            if (filters.length > 1) {
                data.filter = {
                    type: 'and',
                    content: filters
                };
            }
            else
                data.filter = filters[0];
        };
        var getReportConfig = function (option) {
            var extraFilter = {};
            var data = {
                report_id: _this.activeTab.id,
                filter: extraFilter
            };
            if (_this.header.searchText) {
                var datatype = _this.activeTab.data.datatype;
                var baseTable = (datatype == 'user') ? 'user' : "".concat(datatype, ".user");
                var fieldKey = void 0;
                var field = _this.header.field;
                if (field) {
                    if (field.joinedproperty && field.search)
                        fieldKey = "".concat(baseTable, ".").concat(field.id, ".").concat(field.search);
                    else
                        fieldKey = "".concat(baseTable, ".").concat(field.id);
                }
                else {
                    if (datatype === 'user') {
                        fieldKey = 'user.$text';
                    }
                    else {
                        fieldKey = "".concat(baseTable, ".name");
                    }
                }
                extraFilter.filter = {
                    type: 'expression',
                    lhs: fieldKey,
                    operation: 'contains',
                    rhs: _this.header.searchText
                };
            }
            if (option.offset)
                extraFilter.offset = option.offset;
            if (option.limit)
                extraFilter.limit = option.limit;
            if (orderOption) {
                if (orderOption[0] === '-') {
                    extraFilter.sortDescending = true;
                    extraFilter.sort = orderOption.slice(1);
                }
                else
                    extraFilter.sort = orderOption;
            }
            return data;
        };
        var cancelReloading, requestIndex = 1;
        var reload = function (option) {
            option = option || {};
            return DI.$q.promise(function (resolve, reject) {
                if (_this.activeTab.id === 'advanced' || _this.activeTab.id === 'filter')
                    return;
                var data = getReportConfig(option);
                if (cancelReloading)
                    cancelReloading.resolve();
                cancelReloading = DI.$q.defer();
                var index = ++requestIndex;
                setTimeout(function () {
                    var _this = this;
                    if (index != requestIndex)
                        return reject();
                    DI.server.post('/api/stats/generic', data, null, null, null, null, { timeout: cancelReloading.promise }).then(function (result) {
                        if (index != requestIndex)
                            return reject();
                        if (result.success) {
                            cancelReloading = null;
                            resolve(result.data);
                        }
                        else {
                            _this.error = true;
                        }
                    });
                }, 100); // debounce
            });
        };
        this.updateTabOrder = function () {
            setTimeout(function () {
                _.pluck(_this.tabs, 'id');
                DI.server.post2('/api/stats/generic/reports/reorder', {
                    order: _.pluck(_this.tabs, 'id')
                });
            }, 100);
        };
        var filterContainsVariable = function (filter, variable) {
            if (!filter) {
                return false;
            }
            if (filter.type == 'expression') {
                return filter.rhs && filter.rhs.indexOf('{' + variable + '}') != -1;
            }
            else {
                for (var i = 0; i < filter.content.length; ++i) {
                    if (filterContainsVariable(filter.content[i], variable)) {
                        return true;
                    }
                }
            }
        };
        this.activeTabDependsOnCurrentSite = function () {
            if (_this.activeTab) {
                return filterContainsVariable(_this.activeTab.data.filter, 'currentsite');
            }
        };
        var _loop_1 = function (name_1) {
            Object.defineProperty(this_1, name_1, { get: function () { return DI.$rootScope[name_1]; } });
        };
        var this_1 = this;
        // proxy links for old advance search
        for (var _i = 0, _a = ['moduleReadAccess', 'getTrainingCards', 'main', 'memberstatuses', 'hasPermission', 'workouttypes', 'users', 'speedy']; _i < _a.length; _i++) {
            var name_1 = _a[_i];
            _loop_1(name_1);
        }
        this.pubsub('selectedSite', function () {
            if (_this.activeTabDependsOnCurrentSite()) {
                reloadReport();
            }
        });
        this.getSaveStateName = function () {
            if (_this.activeTab) {
                return _this.activeTab.id + _this.activeTab.name;
            }
        };
    }
});
